<!--
######################################################################
table
-- thead
---- th(expand-icon); th(row with the headers); th(editButton)
---------------------- tr
------------------------ th* (headers)
---------------------- tr
------------------------ th* (forms)
-- tbody
-- tr*
---- td(expand-icon); td(tr row with the data); td(editButton)
---------------------- tr
------------------------ th* (data)
---------------------- tr
------------------------ th* (expand template)
######################################################################
-->

@if (onNewElement.observers.length!=0) {
  <button mat-icon-button (click)="onNewElement.emit({})" matTooltip="New Row">
    <mat-icon aria-label="Add new element to the current table">add_circle</mat-icon>
  </button>
}
@if (onRefresh.observers.length!=0) {
  <button mat-icon-button (click)="onRefresh.emit({})" matTooltip="Refresh the current table">
    <mat-icon>refresh</mat-icon>
  </button>
}
<ng-container *ngTemplateOutlet="additionalToolbarActionsTemplate!"></ng-container>
<table style="width: auto;" class="mat-table-custom">
  <thead>
    @if (showSearch) {
      <tr>
        <!-- search input boxes -->
        <th>&nbsp;</th>
        @if (selectable) {
          <th>&nbsp;</th>
        }
        @if (rowEditTemplate||additionalRowActionsTemplate||onDelete.observers.length!=0) {
          <th>&nbsp;</th>
          } <!-- to edit button -->
        </tr>
      }
    </thead>
  </table>




  <!--<div id="{{idtable}}" class="divTable">-->
  <table id="{{idtable}}" class="fixed_headers" style="width: auto;">
    <!--<div class="divTableHeading">-->
    <thead>
      <tr>
        <th>
          <table>
            <thead>
              <tr>
                @if (!isToShowSearchButton()) {
                  <th>&nbsp;</th>
                }
                @if (isToShowSearchButton()) {
                  <th>
                    <button class="button-filter" type="button" (click)="showSearchForm()">&nbsp;</button>
                  </th>
                }
                @if (selectable) {
                  <th><input type="checkbox" (click)="onCheckedAll($event)" /></th>
                  } <!-- to select -->
                  @for (l of header; track l; let i = $index) {
                    <th title="{{l.title}}">
                      <!--<ng-container *ngTemplateOutlet="headerdata"></ng-container>-->
                      @if (!l.show) {
                        <span>&nbsp;</span>
                      }
                      @if (l.show) {
                        <div class="search">{{l.label}}</div>
                      }
                    </th>
                  }
                  @if (rowEditTemplate||additionalRowActionsTemplate||onDelete.observers.length!=0) {
                    <th>&nbsp;</th>
                    } <!-- to edit button -->
                  </tr> <!--divTableRow-->
                </thead>
              </table>
            </th>
          </tr>
        </thead> <!--divTableHeading-->

        <tbody>
          <!--class="divTableBody"-->
          @if (newRow) {
            <tr>
              <ng-container *ngTemplateOutlet="rowNewTemplate!"></ng-container>
            </tr>
          }

          @for (d of data; track d; let r = $index) {
            <tr id="row-{{idtable}}-{{r}}">
              <!--class="divTableRow"-->
              <!-- table data -->
              <td>
                <table>
                  <tbody class="inner">
                    <!-- row to show the form to create a record -->
                    @if (editing[r]) {
                      <tr>
                        <td [attr.colspan]="header.length" style="width:auto;">
                          <ng-container *ngTemplateOutlet="rowEditTemplate!; context:{value:d, index:r}"></ng-container>
                        </td>
                      </tr>
                    }
                    @if (!editing[r]) {
                      <tr>
                        @if (collapsible) {
                          <td (click)="onExpandRow($event, r)">
                            @if (!expanded[r]) {
                              <span><strong style="font-size:large;">+</strong></span>
                            }
                            @if (expanded[r]) {
                              <span><strong style="font-size:large;">-</strong></span>
                            }
                          </td>
                        }
                        @if (!collapsible) {
                          <td>&nbsp;</td>
                          } <!-- to expand -->
                          @if (selectable) {
                            <td><input type="checkbox" [checked]="isRowChecked(r)" (click)="onCheck($event, r)" /></td>
                            } <!-- to select -->
                            @for (l of header; track l; let c = $index) {
                              <td [ngClass]="getClass(r, c)" title="{{l.label}}: {{l.title}}" (click)="onCellClick(r, c)">
                                @if (!l.show) {
                                  <span>&nbsp;</span>
                                }
                                @if (!l.checkbox&&l.show) {
                                  <span>{{getData(r, c)}}</span>
                                }
                                @if (l.checkbox&&l.show) {
                                  <span><input type="checkbox" [checked]="isInputChecked(r, c)" value="1" onclick="return false;" /></span>
                                }
                              </td>
                            }
                            @if (rowEditTemplate||additionalRowActionsTemplate||onDelete.observers.length!=0) {
                              <td class="button-actions">
                                <ng-container matColumnDef="Actions">
                                  <ng-container *ngTemplateOutlet="additionalRowActionsTemplate!; context:{value:d, index:r}"></ng-container>
                                  @if (collapsible&&expanded[r]&&onNewChild.observers.length!=0) {
                                    <button mat-icon-button (click)="onRowNewChild(d,r)" matTooltip="new Child">
                                      <mat-icon aria-label="Add new Child">add</mat-icon>
                                    </button>
                                  }
                                  @if (rowEditTemplate) {
                                    <button mat-icon-button (click)="onRowEdit(d,r)" matTooltip="Edit Row" [disabled]="editing[r]">
                                      <mat-icon aria-label="Edit">edit</mat-icon>
                                    </button>
                                  }
                                  @if (onDelete.observers.length!=0) {
                                    <button mat-icon-button #deleteRowButton id="deleteRowButton-{{r}}" (click)="onRowDelete(d,r)" matTooltip="Delete Row">
                                      <mat-icon aria-label="Delete">delete</mat-icon>
                                    </button>
                                  }
                                </ng-container>
                                <!--<button *ngIf="collapsible&&expanded[r]&&onNewChild.observers.length!=0"
                                type="button"
                                title="new Child"
                                class="btn btn-default"
                                (click)="onRowNewChild(d,r)">
                                +
                              </button>-->
                              <!--<button *ngIf="rowEditTemplate"
                              type="button"
                              class="btn btn-default"
                              [disabled]="editing[r]"
                              (click)="onRowEdit(d,r)">
                              {{editLabel}}
                            </button>-->
                            <!--<button *ngIf="isToShowDeleteButton()"
                            type="button"
                            title="Delete Record"
                            class="btn btn-danger"
                            (click)="onRowDelete(d,r)">
                            Delete
                          </button>-->
                        </td>
                      }
                    </tr>
                  }
                  <tr [ngClass]="expandrowclass[r]">
                    <td>&nbsp;</td> <!-- collapsible-->
                    @if (selectable) {
                      <td>&nbsp;</td>
                      } <!-- selectable-->
                      <td [attr.colspan]="header.length" class="expand-container" style="width:100%; border-color: black; border-style:solid; border-width:1px;">
                        <ng-container *ngTemplateOutlet="rowExpandTemplate!; context:{value:d, index:r}"></ng-container>
                      </td>
                      @if (rowEditTemplate||additionalRowActionsTemplate||onDelete.observers.length!=0) {
                        <td>&nbsp;</td>
                        } <!-- buttons -->
                      </tr>
                    </tbody>
                  </table>
                </td>
                <!-- divTable data -->
                <!--<div class="divTableRow" id="rowdata-{{idtable}}" *ngIf="editing[r]">
              </div>
              <div class="divTableRow" id="rowdata-{{idtable}}" *ngIf="!editing[r]">
                <div class="divTableCell" *ngFor="let l of header; index as c" [ngClass]="getClass(r, c)" title="{{l.label}}">
                  <span *ngIf="!l.checkbox">{{getData(r, c)}}</span>
                  <span *ngIf="l.checkbox"><input type="checkbox" [checked]="isInputChecked(r, c)" value="1" onclick="return false;" /></span>
                </div>
              </div>-->
              <!--divTableRow-->
              <!--<div class="divTableRow" [ngClass]="expandrowclass[r]">
            </div>-->
          </tr>
          } <!-- divTableRow -->
        </tbody> <!--divTableBody-->
      </table> <!--divTable-->
